export default __webpack_public_path__ + "static/media/topic-fill-gray5-24.adb690dd.svg";